import { cleanupEmptyValues } from 'yggdrasil/src/cfLodash'

/**
 * Generate a Universally Unique Identifier (UUID)
 *
 * Cryptographically random where the platform allows: request_idempotency
 * keys are security-bearing, and Math.random's state is recoverable from
 * observed outputs. crypto.randomUUID exists in all modern browsers on
 * secure contexts; the fallback keeps old behaviour elsewhere.
 * @see https: //stackoverflow.com/a/2117523/38375
 * @returns {string} the generated UUID
 */
export function uuidv4(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export function IntlTel_initPhoneInput(inputElement: HTMLInputElement, options: any = {}): Promise<any> {
  options = cleanupEmptyValues(options)
  const iti = (window as any).intlTelInput(inputElement, {
    autoPlaceholder: 'aggressive',
    countryOrder: ['us', 'ca', 'gb', 'ie', 'ai', 'nz'],
    // TODO: I think the intialCountry logic should be placed in here
    // - First try to get the country from garlic
    // - Second from cfVisitorData
    // - Third from the browser
    // - Fourth falls back to US
    initialCountry: 'us',
    countrySearch: false,
    fixDropdownWidth: false,
    // NOTE: This follows the docs recommendation to load utils script separately
    // @ts-expect-error - dynamic import from CDN URL
    loadUtils: () => import('https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/25.5.2/build/js/utils.min.js'),
    ...options,
  })

  ;(inputElement as any).iti = iti
  return iti.promise
}

export function isEventInside(event: MouseEvent, element: Element): boolean {
  return event.target === element || element.contains(event.target as Element)
}

export function closeOnClickOutside(element: Element, cb: () => void): void {
  document.addEventListener(
    'click',
    (evt) => {
      if (evt.target !== element && !element.contains(evt.target as Element)) {
        cb()
      }
    },
    { capture: true }
  )
}

export function range(min: number, max: number, step = 1): number[] {
  let arraySize = Math.floor((max - min) / step)
  if (arraySize < 0) arraySize = 0
  return new Array(arraySize).fill(0).map((_, index) => index * step + min)
}

export function removePageScroll(): void {
  document.body.classList.add('remove-page-scroll')
}

export function addPageScroll(): void {
  document.body.classList.remove('remove-page-scroll')
}

export function isWithinCustomerCenterView() {
  const params = new URLSearchParams(window.location.search)
  const previewDynamicSection = !!params.get('preview-dynamic-section')
  return previewDynamicSection && window.self !== window.parent
}
